import { StorageManager } from './StorageManager';
import { TokenManager } from './TokenManager';
import { API_ENDPOINTS, getApiUrl } from '../../config/api';

// Create singleton instances of managers
export const storageManager = new StorageManager();
export const tokenManager = new TokenManager();

// Create and export a default authService object
const authService = {
  storageManager,
  tokenManager,
  
  // Helper method to validate token with server
  async validateToken(token) {
    try {
      console.log('authService.validateToken called with token:', token);
      
      // First validate token format locally
      const formatValidation = tokenManager.validateFormat(token);
      if (!formatValidation.isValid) {
        console.warn('Local token validation failed:', formatValidation.error);
        return {
          success: false,
          message: formatValidation.error || 'Token inválido'
        };
      }
      
      // Then validate with server
      const response = await fetch(getApiUrl(API_ENDPOINTS.validateToken), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ token })
      });
      
      if (!response.ok) {
        console.warn('Server validation failed with status:', response.status);
        return {
          success: false,
          message: `Error de validación (${response.status})`
        };
      }
      
      const data = await response.json();
      
      if (!data.success) {
        console.warn('Server validation returned error:', data.message);
        return {
          success: false,
          message: data.message || 'Token inválido'
        };
      }
      
      console.log('Token validation successful:', data);
      return data;
    } catch (error) {
      console.error('Token validation error:', error);
      return {
        success: false,
        message: error.message || 'Error al validar el token'
      };
    }
  },

  /**
   * Register a direct student and generate a token
   * @param {Object} studentData - Student data
   * @param {string} studentData.name - Student name
   * @param {string} studentData.email - Student email
   * @returns {Promise<Object>} Registration result
   */
  async registerDirectStudent(studentData) {
    try {
      console.log('authService.registerDirectStudent called with data:', studentData);
      
      // Validate input data
      if (!studentData.name || !studentData.email) {
        return {
          success: false,
          message: 'Nombre y email son obligatorios'
        };
      }
      
      // Call the API to register the student
      const response = await fetch(getApiUrl(API_ENDPOINTS.directStudentRegister), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(studentData)
      });
      
      if (!response.ok) {
        console.warn('Direct student registration failed with status:', response.status);
        return {
          success: false,
          message: `Error de registro (${response.status})`
        };
      }
      
      const data = await response.json();
      
      if (!data.success) {
        console.warn('Direct student registration returned error:', data.message);
        return {
          success: false,
          message: data.message || 'Error en el registro'
        };
      }
      
      console.log('Direct student registration successful:', {
        success: data.success,
        hasToken: Boolean(data.token),
        hasStudent: Boolean(data.student)
      });
      
      return {
        success: true,
        token: data.token,
        student: data.student
      };
    } catch (error) {
      console.error('Direct student registration error:', error);
      return {
        success: false,
        message: error.message || 'Error en el registro'
      };
    }
  }
};

export default authService;